import styled from 'styled-components';

import { v4 as uuidv4 } from 'uuid';
import { AutoAwesomeOutlined, DoNotDisturbAltOutlined } from '@mui/icons-material';
import { Button } from '@common/Button';
import { AIAssistant } from '@requests/telnyx';
import { useDispatch } from 'react-redux';
import { assistantActions } from '@store/slices/assistant';

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 0.75rem;
  padding: 0 2rem;

  h1 {
    color: ${({ theme }) => theme.text.standard};
    text-align: center;
  }

  p {
    font-size: 14px;
    text-align: center;
    color: ${({ theme }) => theme.text.subtext};
  }
`;

const NotSelectedIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.line.light};
  border-radius: 8px;
  padding: 8px;
  color: ${({ theme }) => theme.text.subtext};
`;

export const AssistantNotSelected = () => {
  const dispatch = useDispatch();

  const createNewAssistant = () => {
    try {
      const defaultAssistant: AIAssistant = {
        id: uuidv4(),
        name: '',
        description: '',
        model: '',
        instructions: '',
        created_at: new Date().toISOString(),
        tools: [],
      };

      dispatch(assistantActions.createNewAssistant(defaultAssistant));
    } catch {}
  };

  return (
    <Container>
      <NotSelectedIcon>
        <DoNotDisturbAltOutlined />
      </NotSelectedIcon>
      <h1>Assistant Not Selected</h1>
      <p>Select an assistant from the list to the left, or create a new one by clicking the button below.</p>
      <Button
        onClick={createNewAssistant}
        startIcon={<AutoAwesomeOutlined fontSize='small' />}
        sx={{ marginTop: '1rem' }}
        customColor='black'
      >
        Create Assistant
      </Button>
    </Container>
  );
};
